define('app/factories/business_contact_form_factory',['app/setup', 'app/views/business_contact_form_view','app/models/business_contact_form'],
  function(takhfifan, businessContactFormView,businessContactForm) {
      $('.tkh-business-contact-form').each(function(){
        new takhfifan.businessContactFormView({
          el: $(this),
          model: new takhfifan.businessContactForm()
        });
      }, this);
});

